<template>
  <button
    v-show="visible"
    :class="['backtop', { mobile: isMobileRoute }]"
    :style="backtopStyle"
    @click="scrollTop"
    aria-label="回到顶部"
    title="回到顶部"
  >
    <img :src="imgSrc" :alt="'回到顶部'" :style="{ width: size + 'px', height: size + 'px' }" />
  </button>
</template>

<script>
export default {
  name: 'BackTop',
  props: {
    isMobileRoute: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      imgSrc: 'https://obs.huahuaeco.com/official/home/BackTop.png',
      footerOffset: 0
    }
  },
  computed: {
    size() {
      return this.isMobileRoute ? 76 : 152
    },
    backtopStyle() {
      const style = {
        width: this.size + 'px',
        height: this.size + 'px'
      }

      if (this.footerOffset > 0) {
        style.bottom = this.footerOffset + 'px'
      }

      return style
    }
  },
  methods: {
    scrollTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    onScroll() {
      this.visible = (window.pageYOffset || document.documentElement.scrollTop || 0) > 200
      this.updateFooterOffset()
    },
    updateFooterOffset() {
      const footer = document.querySelector('.feature-pill')
      if (!footer) {
        this.footerOffset = 0
        return
      }

      const footerStyle = window.getComputedStyle(footer)
      const footerRect = footer.getBoundingClientRect()
      const isFooterVisible = footerStyle.display !== 'none' && footerStyle.visibility !== 'hidden' && footerRect.width > 0 && footerRect.height > 0

      if (!isFooterVisible) {
        this.footerOffset = 0
        return
      }

      const viewportHeight = window.innerHeight || document.documentElement.clientHeight
      const footerBottom = Math.max(0, viewportHeight - footerRect.bottom)
      this.footerOffset = Math.ceil(footerBottom + footerRect.height + 16)
    }
  },
  mounted() {
    this.onScroll()
    this._onScroll = this.onScroll.bind(this)
    this._onResize = this.updateFooterOffset.bind(this)
    window.addEventListener('scroll', this._onScroll, { passive: true })
    window.addEventListener('resize', this._onResize)
    this.$nextTick(this.updateFooterOffset)
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this._onScroll)
    window.removeEventListener('resize', this._onResize)
  }
}
</script>

<style scoped>
.backtop{position:fixed;right:calc(48 * var(--rpx));bottom:calc(48 * var(--rpx));padding:0;border:0;background:transparent;cursor:pointer;z-index:999;display:flex;align-items:center;justify-content:center}
.backtop.mobile{right:calc(12 * var(--rpx));bottom:calc(24 * var(--rpx))}
.backtop img{display:block}

@media (max-width: 1300px), (max-height: 720px) {
  .backtop:not(.mobile) {
    width: 104px !important;
    height: 104px !important;
    right: 24px;
    bottom: 24px;
  }

  .backtop:not(.mobile) img {
    width: 104px !important;
    height: 104px !important;
  }
}

@media (max-width: 900px), (max-height: 620px) {
  .backtop:not(.mobile) {
    width: 84px !important;
    height: 84px !important;
    right: 16px;
    bottom: 16px;
  }

  .backtop:not(.mobile) img {
    width: 84px !important;
    height: 84px !important;
  }
}
/* .backtop:focus{outline:2px solid rgba(0,123,255,0.6)} */
</style>
